import { useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const RichTextEditor = ({ name, value, onChange, error, height = 300 }) => {
  const quillRef = useRef();

  useEffect(() => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      if (editor && value !== editor.root.innerHTML) {
        editor.root.innerHTML = value || "";
      }
    }
  }, [value]);

  const handleChange = (content) => {
    onChange && onChange({ target: { name, value: content } });
  };

  return (
    <div className="tiny-editor-wrapper">
      <ReactQuill
        ref={quillRef}
        value={value}
        onChange={handleChange}
        style={{ height }}
        modules={{
          toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
          ],
        }}
        formats={[
          "header",
          "bold", "italic", "underline",
          "list", "bullet",
        ]}
      />
      {error && <span className="error invalid-feedback">{error}</span>}
    </div>
  );
};

export default RichTextEditor;
